const month = function (day: number): Date {
  const today = new Date();
  return new Date(today.getFullYear(), today.getMonth(), day);
};

export default {
  month,
};
